import { isNil, keyBy, pullAll } from 'lodash';
import { AnnotationEntityExternal } from '../../../team-apis/otterdam/annotations';
import {
  isObjectEntity,
  isShapeEntity,
} from '../../shared/utils/annotation-external-utils';

export function filterOrphanEntities(annotations: AnnotationEntityExternal[]) {
  const objects = keyBy(annotations.filter(isObjectEntity), 'objectId');
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- dictionary[key] can be undefined
  const annotationsWithoutObjects = annotations.filter((annotation) => {
    if ('objectId' in annotation && !isNil(annotation.objectId)) {
      return !objects[annotation.objectId];
    }
    return false;
  });
  pullAll(annotations, annotationsWithoutObjects);

  const shapes = keyBy(annotations.filter(isShapeEntity), 'shapeId');
  const annotationsWithoutShapes = annotations.filter((annotation) => {
    if ('shapeId' in annotation && !isNil(annotation.shapeId)) {
      return (
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- dictionary[key] can be undefined
        !shapes[annotation.shapeId] ||
        shapes[annotation.shapeId].outputId !== annotation.outputId
      );
    }
    return false;
  });
  pullAll(annotations, annotationsWithoutShapes);

  return [...annotationsWithoutObjects, ...annotationsWithoutShapes];
}
